import { Box } from '@customink/pigment-react';
import { useTheme } from '@mui/material/styles';

import colorWheel from '@/assets/colorWheel.svg';

export function ColorWheelIcon() {
  const theme = useTheme();
  const iconSize = theme.typography.htmlFontSize;

  return (
    <Box height={iconSize} lineHeight={1} width={iconSize}>
      <img
        alt="add another color"
        src={colorWheel}
        style={{
          height: '100%',
          width: '100%',
        }}
      />
    </Box>
  );
}
